// ----------------------------------------------------------------------------
// Component: Today's Deal
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import 'snippets/card/card';
import './_todays-deal.scss';